import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/superagent-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-691b9e3d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "powered-by"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["alt"]
const _hoisted_5 = { class: "inline align-middle" }

import { defineComponent, computed } from "vue";
import { mostReadable, readability } from "@ctrl/tinycolor";
import { css } from "@emotion/css";
import { useWidgetTheme } from "@/composables/widgetTheme";
import { useI18n } from "vue-i18n";
import { useWidgetConfig } from "@/composables/widgetConfig";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { theme } = useWidgetTheme();
const { t } = useI18n();

const { branding } = useWidgetConfig();

const productName = computed(() => branding.value?.productName);
const productWebsite = computed(() => branding.value?.productWebsite);

const showLogo = computed(() => {
  if (productName.value !== "Superagent") {
    return false;
  }

  if (!theme.value?.mainBackgroundColor) {
    console.debug("No background color in theme, hiding logo");
    return false;
  }

  const contrast = readability(theme.value.mainBackgroundColor, "#FFFFFF");
  return contrast === 1;
});

const textClass = computed(() => {
  const textColor =
    mostReadable(theme.value?.mainBackgroundColor ?? "#FFFFFF", [
      "#a9a9a9",
      "#d1d1d1",
    ])?.toHexString() ?? "#a9a9a9";

  return css`
    color: ${textColor};

    &:hover {
      color: #999;
    }
  `;
});

return (_ctx: any,_cache: any) => {
  const _directive_svg_inline = _resolveDirective("svg-inline")!

  return (_unref(productName))
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createElementVNode("a", {
          class: _normalizeClass([_unref(textClass), "px-2 py-1 hover:bg-gray-200 rounded-xl text-xs mb-2 mt-4 transition-colors"]),
          href: 
        _unref(productWebsite) + '/?utm_medium=chat_widget&utm_campaign=powered_by'
      ,
          target: "_blank"
        }, [
          (_unref(showLogo))
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _withDirectives(_createElementVNode("img", {
                  class: "inline mr-2 h-6 w-6 text-gray-400 group-hover:text-gray-500 transition-colors fill-current",
                  src: _imports_0,
                  alt: _unref(productName) + ' logo'
                }, null, 8, _hoisted_4), [
                  [_directive_svg_inline]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)("messengerPoweredByFooter.weRunOn", { productName: _unref(productName) })), 1)
        ], 10, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}
}

})